module.exports = __webpack_public_path__ + "static/media/logo-blue-ribbon-bags.8ac6a7af.svg";